import React from 'react'
import {motion} from "motion/react"
import {LoaderCircle} from "lucide-react";


const LoadingComponent = () => {
    return <motion.div
        animate={{
            rotate: [0, 360],
        }}
        transition={{
            duration: 0.9,
            repeat: Infinity,
            ease: "linear"
        }}>
        <LoaderCircle style={{fontSize: 27, color: "white"}}/>

    </motion.div>
}

export default LoadingComponent